import React, { forwardRef, useEffect } from 'react';
import { InputListItem } from '..';
export var InputRadio = forwardRef(function (_a, ref) {
    var name = _a.name, legend = _a.legend, options = _a.options, setValue = _a.setValue, value = _a.value, onChange = _a.onChange, disabled = _a.disabled;
    useEffect(function () {
        var _a, _b;
        if (value && name) {
            var target = (_b = (_a = options === null || options === void 0 ? void 0 : options.find(function (opt) { return opt.value == value || opt.id.toString() == value; })) === null || _a === void 0 ? void 0 : _a.id.toString()) !== null && _b !== void 0 ? _b : value;
            setValue(name, target);
        }
    }, [value, name, options]);
    return (React.createElement("fieldset", null,
        React.createElement("legend", null, legend),
        React.createElement("div", { className: "l-flex l-flex--wrap" }, options === null || options === void 0 ? void 0 : options.map(function (option) { return (React.createElement("div", { key: option.id },
            React.createElement(InputListItem, { type: "radio", id: "".concat(name, "--").concat(option.id), name: name, value: option.id.toString(), displayText: option.value, ref: ref, onChange: onChange, disabled: disabled }))); }))));
});
InputRadio.displayName = 'InputRadio';
